// A roster artist's own photo.
//
// A non-component module, the same reason `rosterFormat.ts` and `dealVocab.ts` are: its two callers are
// components, and mixing a hook in with them costs fast refresh.
//
// **It used to be the one place the band-avatar fetch was arranged for an ORG seat** — `useMediaObjectUrl`
// riding `bandScopedPath` so the request went through the org-lens mirror, because a band-direct media route
// is one an org seat cannot resolve and it fails SILENTLY (the hook degrades to `error: true` and the tile
// renders empty). That arrangement is GONE, and with it the whole class of problem: a band's picture is
// identity, it lives in the global avatar store, and the route that serves it has no tenant in the path for
// a lens to rewrite. Anyone signed in can render it — which is the point, since a band's picture is looked
// at by friends, by orgs weighing a link, and by the support directory, none of whom reach that band.
import { useAvatarUrl } from "../../app/hooks/useAvatar.js";

/** The object URL for one band's avatar. Undefined until (or unless) there is a photo. */
export function useArtistPhotoUrl(bandId: string | null | undefined, avatarMediaId: string | null | undefined) {
  return useAvatarUrl("band", bandId, avatarMediaId);
}
